import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "admin/company"

class companyService {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getResume(companyId) {
        return http.get(path + '/resume/' + companyId);
    }

    getAllCompanies() {
        let params = new URLSearchParams()
        params.set("status", "1")
        return http.list(path + "/selectAll",params);
    }



}

export default new companyService();


